import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type PackageTemplatesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function PackageTemplatesToolbar({
  canManage,
  onCreate,
}: PackageTemplatesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div className="flex items-center gap-2">
          <div className="">
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              Template ແພັກເກດ
            </h2>
            <p className="text-muted-foreground">
              ຈັດການ template ແພັກເກດທີ່ສາມາດຂາຍໃຫ້ນັກຮຽນໄດ້.
            </p>
          </div>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງ Template
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
